export class DateConstants {
  public static MILLISECONDS_PER_SECOND = 1000;
  public static SECONDS_PER_MINUTE = 60;
  public static MINUTES_PER_HOUR = 60;
  public static HOURS_PER_DAY = 24;

  public static JANUARY = 0;
  public static DAY_BEFORE_FIRST = 0;

  public static MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000; // 86400000
  public static DAYS_IN_WEEK = 7;
  public static THURSDAY_OFFSET = 4;
  public static FIRST_DAY_OF_MONTH = 1;
}
